import React from 'react';
import axios from 'axios';
import { Grid, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import AutocompleteFilter from '../elements/AutocompleteFilter.tsx';
import { FilterContextEl, useFilter } from '../providers/FilterProvider.tsx';
import '../../style/home.css'
import dayjs from 'dayjs';
import { GraphData, FilterData, DefaultValues } from '../elements/DashboardElement.tsx';
import Dashboard from '../elements/Dashboard.tsx';
import { filter_style, onairLocalFilter, onairTimeZoneFilter } from '../utils/filterUtils.tsx';
import { darkTheme } from '../utils/graphUtils.tsx';
import { getDefaultStartDate, getDefaultEndDate, getLastAvailableDay } from '../utils/dateLimits.tsx';

const DashboardContainer = ({indexDashboard, idDashboard, setIsError, isLargeScreen, helpId, handleChange}) => {
    const { addFilters, isAllSelected, getFilterValueList, setFilterValueList, getFilteredOptionList } = useFilter();
    const [filtersList, setFiltersList] = React.useState<FilterContextEl[]>([]);
    const [localFiltersList, setLocalFiltersList] = React.useState<any[]>([]);
    const [currentDashboardGraph, setCurrentDashboardGraph] = React.useState<FilterContextEl[]>([]);

    function callMutationData(type='update') {
      const currentDashboard = GraphData[idDashboard.toLowerCase()]
      if(!['settings','help'].includes(idDashboard.toLowerCase()))
        if(currentDashboard) {
          setCurrentDashboardGraph([]);
          setIsError({label: '', message: ''})
          if(idDashboard.toLowerCase() !== 'overview'){
            currentDashboard.forEach(graphItem => {
              /*
              graphItem.payload['start_date'] = (type==='update')?getFilterValueList('startDate').format('YYYY-MM-DD'):dayjs().subtract(1, 'week').format('YYYY-MM-DD');
              graphItem.payload['end_date'] = (type==='update')?getFilterValueList('endDate').format('YYYY-MM-DD'):dayjs().format('YYYY-MM-DD');
              */
              // Real time: finestra fino a "adesso" (i selettori data sono nascosti); le altre dashboard
              // partono dall'ultimo giorno disponibile (oggi - 3 giorni).
              const isRealTime = idDashboard.toLowerCase() === 'real_time';
              const startValue = (isRealTime) ? dayjs().subtract(1, 'week') : (type==='update') ? getFilterValueList('startDate') : getDefaultStartDate();
              const endValue = (isRealTime) ? dayjs() : (type==='update') ? getFilterValueList('endDate') : getDefaultEndDate();
              graphItem.payload['start_date'] = startValue.format('YYYY-MM-DD HH:mm');
              graphItem.payload['end_date'] = endValue.format('YYYY-MM-DD HH:mm');
              
              let filterToApply = (['social_pages', 'real_time'].includes(idDashboard.toLowerCase()) && graphItem.filtersList)
                ?[...filtersList, ...localFiltersList.filter(el => graphItem.filtersList.includes(el.name))]
                :filtersList;

              filterToApply.forEach((selectedFilter) => {
                let newSelected = (type==='update')?getFilterValueList(selectedFilter.name) : (selectedFilter.type !== "multiselector")?[]:DefaultValues[selectedFilter.name.replace(idDashboard+'_', '')]
                if((!Array.isArray(newSelected) && selectedFilter.type !== "multiselector")) newSelected = [newSelected]

                let newValue = (newSelected)? newSelected.map(el => el.id) : []
                graphItem.payload[selectedFilter.name.replace(idDashboard+'_', '')] = (['real_time'].includes(idDashboard.toLowerCase())) ? newValue[0] : newValue
              });
            });
          }

          setCurrentDashboardGraph([...currentDashboard])       
        } 
        else setIsError({ label: 'data', message: `Data for one or more charts not available` });
    };  // Dependency array to ensure `callMutationData` is stable

    const fetchFilters = () => {
      if(idDashboard==='social_pages') return axios.post(process.env.REACT_APP_BACKEND_URL+ 'social_filters/', FilterData[idDashboard] );
      return axios.post(process.env.REACT_APP_BACKEND_URL+'filters/', FilterData[idDashboard] );
    };

    const FILTERS_MAX_RETRIES = 3;
    const FILTERS_RETRY_DELAY_MS = 800;

    const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

    // Il backend a volte risponde 200 con un body vuoto/non valido invece dell'array
    // di filtri atteso: si ritenta un paio di volte prima di rinunciare.
    const getFilters = (attempt = 1) => {
      return new Promise((resolve, reject) => {
        fetchFilters()
          .then((response) => {
            if (!Array.isArray(response.data) && attempt < FILTERS_MAX_RETRIES) {
              console.warn(`Risposta filtri non valida (tentativo ${attempt}/${FILTERS_MAX_RETRIES}), ritento (`, idDashboard, ')');
              resolve(wait(FILTERS_RETRY_DELAY_MS).then(() => getFilters(attempt + 1)));
              return;
            }
            resolve({ data: response.data });
          })
          .catch((error) => {
            // Errori di rete o 5xx transitori: si ritenta come per le risposte non valide.
            // I 4xx sono definitivi (richiesta sbagliata), inutile ripetere.
            const status = error?.response?.status;
            if (attempt < FILTERS_MAX_RETRIES && (!status || status >= 500)) {
              console.warn(`Errore nel caricamento dei filtri (tentativo ${attempt}/${FILTERS_MAX_RETRIES}), ritento (`, idDashboard, ')');
              resolve(wait(FILTERS_RETRY_DELAY_MS).then(() => getFilters(attempt + 1)));
              return;
            }
            reject(error);
          });
      });
    };

    function callMutationEntityFilters() {
      // Overview e UAE non hanno colonne da filtrare: il backend risponderebbe 400
      // ("Table name and columns must be specified").
      if (!FilterData[idDashboard]?.columns?.length) return;
      getFilters()
        .then((response: any) => {
          console.log("Risposta backend Filtri (", idDashboard, "):", response.data);

          // 1. CONTROLLO DI SICUREZZA
          // Se response.data non è un array, stampiamo un avviso e usiamo un array vuoto come fallback.
          let rawData = [];
          if (Array.isArray(response.data)) {
            rawData = response.data;
          } else {
            console.warn("ATTENZIONE: Il backend non ha restituito un array per i filtri! Ha restituito:", typeof response.data, response.data);
            // Se per caso il backend invia i dati dentro un'altra proprietà (es. response.data.filters), potresti gestire il caso qui.
            // rawData = response.data?.filters || [];
          }

          // 2. Usiamo rawData invece di response.data
          let filtersData: FilterContextEl[] = rawData.map(el => {
            return {...el, id:idDashboard+'_'+el.id, name:idDashboard+'_'+el.name}
          });

          if(idDashboard.toLowerCase() === 'social_pages'){
            console.log("Filtri mappati per social_pages prima dell'unione:", filtersData);

            let pageNameFilters = filtersData.filter(el => el.name.includes('page_name'));
            let mergedOptionList: any[] = [];
            let seenOptionIds = new Set();
            pageNameFilters.forEach(pf => {
              (pf.optionList || []).forEach(option => {
                if (!seenOptionIds.has(option.id)) {
                  seenOptionIds.add(option.id);
                  mergedOptionList.push(option);
                }
              });
            });
            let globalFilters = pageNameFilters.length > 0
              ? [{ ...pageNameFilters[0], optionList: mergedOptionList }]
              : [];
            let localFiltersData = filtersData.filter(el => !el.name.includes('page_name')).map(el => { return{...el, type:"selector", selectedValue:el.optionList[0]}});
            let newList = [...globalFilters, ...localFiltersData];
            let newFlagList = [...Array.from({ length: globalFilters.length }, () => true), ...Array.from({ length: localFiltersData.length }, () => false)]

            console.log("Global Filters salvati nello state:", globalFilters);
            console.log("Local Filters salvati nello state:", localFiltersData);
            
            if (localFiltersData.length > 0) {
              setLocalFiltersList(localFiltersData)
            }
            
            setFiltersList(globalFilters);
            addFilters(idDashboard, newList, newFlagList);
          }

          else {
            setFiltersList(addFilters(idDashboard, filtersData, Array.from({ length: filtersData.length }, () => true)));
          }
        })
        .catch((error) => {
          console.error("Errore nella chiamata a getFilters (", idDashboard, "):", error);
        });
    }

    const handlerReset = () => {
      setFilterValueList('startDate', getDefaultStartDate(), getDefaultStartDate())
      setFilterValueList('endDate', getDefaultEndDate(), getDefaultEndDate())

      filtersList.forEach((selectedFilter) => {
        setFilterValueList(selectedFilter.id, [], null)
      });

      localFiltersList.forEach((selectedFilter) => {
        setFilterValueList(selectedFilter.id, [], null)
      });

      callMutationData('reset')
    };

    const handlerUpdate = () => {
      callMutationData();
    };

    React.useEffect(() => {
      if((filtersList || ['overview'].includes(idDashboard.toLowerCase())) && currentDashboardGraph.length === 0)
        callMutationData();
    }, [filtersList]);

    React.useEffect(() => {
      if(['social_pages'].includes(idDashboard.toLowerCase()) ) {
        let proxyFilters = FilterData[idDashboard]["columns"].filter(el => el !== 'metric_name').map((el) => {return {"name":"","id":"","impacted":[],"filtered": null,"optionList":[],"type":"multiselector","isAllSelected": false}})
        setFiltersList(proxyFilters)

        proxyFilters = FilterData[idDashboard]["localFilters"].map((el) => {return {"name":el,"id":"","impacted":[],"filtered": null,"optionList":[],"type":(el.includes('page_name'))?"multiselector":"selector","isAllSelected": false}})
        setLocalFiltersList(proxyFilters.filter(el => !el.name.includes('page_name')))
      }
      else if(idDashboard.toLowerCase() === 'real_time'){
            let newList = [...onairLocalFilter, ...onairTimeZoneFilter];
            let newFlagList = [...[false, false]]
            
            setLocalFiltersList(newList)
            setFiltersList([]);
            addFilters(idDashboard, newList, newFlagList)
          }
      else if(!['settings','help','overview'].includes(idDashboard.toLowerCase())) {
        let proxyFilters = FilterData[idDashboard]["columns"].map((el) => {return {"name":"","id":"","impacted":[],"filtered": null,"optionList":[],"type":"multiselector","isAllSelected": false}})
        setFiltersList(proxyFilters)
      }

      if(!['real_time','settings','help'].includes(idDashboard.toLowerCase()))callMutationEntityFilters();
    }, []);

    return (
        <Grid container
            direction="column"
            justifyContent="center"
            alignItems="stretch"
            gap='20px'>

            {!['settings','help','overview'].includes(idDashboard.toLowerCase()) && (filtersList.length > 0 || localFiltersList.length > 0 || ['uae'].includes(idDashboard.toLowerCase())) && 
              <Grid container spacing={{ xs: 2, md: 3 }} sx={{justifyContent:'space-between'}}>    
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <ThemeProvider theme={darkTheme}>

                    {!['real_time'].includes(idDashboard.toLowerCase()) &&
                      <Grid key={'start-date'} item container xs={12} md={6} lg={4} xl={12/(filtersList.length+3)} direction='row' sx={{ justifyContent: "center", alignItems: "center" }}>
                        <DateTimePicker
                          label="Data di Inizio"
                          value={getFilterValueList('startDate')}
                          onChange={(newValue) => {
                            setFilterValueList('startDate', newValue, newValue)
                          }}                        
                          sx={filter_style}
                          className="custom-filter"
                          maxDate={getFilterValueList('endDate')}
                          format="DD/MM/YYYY HH:mm"  // Formato per mostrare anche l'ora
                          ampm={false}
                          minutesStep={1}timeSteps={{ minutes: 1 }}
                          slots={{
                            actionBar: () => null,       // Rimuove la barra dei pulsanti (OK e Cancel)
                          }}
                        />
                      </Grid>
                    }

                    {!['real_time'].includes(idDashboard.toLowerCase()) &&
                      <Grid key={'end-date'} item container xs={12} md={6} lg={4} xl={12/(filtersList.length+3)} direction='row' sx={{ justifyContent: "center", alignItems: "center" }}>
                        <DateTimePicker
                          label="Data di Fine"
                          value={getFilterValueList('endDate')}
                          onChange={(newValue) => {
                            setFilterValueList('endDate', newValue, newValue);
                          }}
                          sx={filter_style}
                          className="custom-filter"
                          minDate={getFilterValueList('startDate')}
                          maxDate={getLastAvailableDay()}
                          format="DD/MM/YYYY HH:mm"  // Formato per mostrare anche l'ora
                          ampm={false}
                          minutesStep={1}timeSteps={{ minutes: 1 }}
                          slots={{
                            actionBar: () => null,       // Rimuove la barra dei pulsanti (OK e Cancel)
                          }}
                        />
                      </Grid> 
                    }
                    
                    {filtersList.length > 0 && filtersList.map((filter, index) => (
                      <Grid key={'filter-'+index} item xs={12} md={6} lg={4} xl={12/(filtersList.length+3)} display="flex" justifyContent="center" alignItems="center">
                        <AutocompleteFilter key={'filter-AutocompleteFilter-'+idDashboard+'-'+index}
                          showSelected={idDashboard !== 'contenuti_on_demand'}
                          filter_style={filter_style}
                          allSelected={isAllSelected(filter.name)}
                          value={getFilterValueList(filter.name)}
                          options={getFilteredOptionList(filter, (filter.filtered && filter.filtered.length > 0)? getFilterValueList(filter.idDashboard+'_'+filter.filtered[filter.filtered.length - 1]) || []: [])}
                          caption={FilterData[idDashboard].columns_alias[index]}
                          name={filter.name}
                          setFilterValueList={setFilterValueList} />                        
                      </Grid>))
                    }

                    {['real_time'].includes(idDashboard.toLowerCase()) && localFiltersList.map((filter, index) => (
                        <Grid key={'local_real_time-'+index} item xs={12} md={4} display="flex" justifyContent="center" alignItems="center">
                          <AutocompleteFilter key={'filter-AutocompleteFilter-local-'+index}
                            disableClearable={true}
                            showSelected={true}
                            filter_style={filter_style}
                            allSelected={false}
                            value={getFilterValueList(filter.name)}
                            options={getFilteredOptionList(filter, [])}
                            caption={FilterData[idDashboard]["columns_alias"][index]}
                            name={filter}
                            className="custom-filter"
                            multiple={false}
                            setFilterValueList={setFilterValueList} />
                        </Grid>
                      ))
                    }

                    {['real_time'].includes(idDashboard.toLowerCase())
                    ?
                      <Grid key={'button-filter2'} item container xs={12} spacing={'24px'} md={12/3} direction='row' sx={{ justifyContent: {xs:"center", md:"flex-end"}, alignItems: "center" }}>
                        <Grid key={'button-filter2'} item xs={12}>
                            <button className={"button-query"} onClick={handlerUpdate}>Aggiorna</button>           
                        </Grid>
                      </Grid>
                    :
                      <Grid key={'button-filter-grid'} item container xs={12} md={(filtersList.length%2===1)?6:12} lg={(filtersList.length%2===1 && idDashboard !== 'contenuti_on_demand')?12:4} spacing={'24px'} xl={12/(filtersList.length+3)} direction='row' sx={{ justifyContent: {xs:"center", md:"flex-end"}, alignItems: "center" }}>
                        <Grid key={'button-filter1'} item xs={6}>
                            <button className={"button-query"} onClick={handlerReset}>Ripristina</button>
                        </Grid>

                        <Grid key={'button-filter2'} item xs={6}>
                            <button className={"button-query"} onClick={handlerUpdate}>Aggiorna</button>           
                        </Grid>
                      </Grid>}
                  </ThemeProvider>
                </LocalizationProvider>
              </Grid>
            }

            <Dashboard currentDashboardGraph={currentDashboardGraph} handlerUpdate={handlerUpdate} indexDashboard={indexDashboard} idDashboard={idDashboard} isLargeScreen={isLargeScreen} helpId={helpId} handleChange={handleChange} filtersList={localFiltersList.reduce((acc, el) => { acc[el.name] = el; return acc; }, {})} />
        </Grid>
    );
};

export default DashboardContainer;